import React from 'react';
import { RefreshCw } from 'lucide-react';

interface LastUpdatedBadgeProps {
    date: string;
    showIcon?: boolean;
}

const LastUpdatedBadge: React.FC<LastUpdatedBadgeProps> = ({ date, showIcon = true }) => {
    const formattedDate = new Date(date).toLocaleDateString('pt-BR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });

    // Check if updated within last 30 days
    const isRecent = (new Date().getTime() - new Date(date).getTime()) < (30 * 24 * 60 * 60 * 1000);

    return (
        <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium ${isRecent
                ? 'bg-green-100 text-green-700 border border-green-200'
                : 'bg-blue-100 text-blue-700 border border-blue-200'
            }`}>
            {showIcon && <RefreshCw className="w-3.5 h-3.5" />}
            <span>
                {isRecent ? '✨ ' : ''}Atualizado em {formattedDate}
            </span>
        </div>
    );
};

export default LastUpdatedBadge;
